import { classNameGenerator } from "@/utils"
import styles from "./WhatYouWillLearn.module.scss"
import Typography from "@/foundation/Typography/V2"
import { Image } from "@/components/Atoms"
import Steps from "./Steps"
import StepAccordion from "./StepAccordion"
import { useAppSelector } from "@/hooks"

const WhatYouWillLearn = () => {
    const cls = classNameGenerator(styles)

    const { data } = useAppSelector((state) => state.bootCamp);

    if(!data?.WhatYouWillLearn)
        return <></>

    return (
        <section id="WhatYouWillLearn">
            <div className={cls("whatYouWillLearnContainer")}>
                <div className={cls("whatYouWillLearnWrapper")}>
                    <div className={cls("topSection")}>
                        <Typography
                            variant="heading4"
                            className={cls("title")}
                            dangerouslySetInnerHTML={{ __html: "What you'll learn" }}
                        />
                    </div>
                    <Steps steps={data?.WhatYouWillLearn}/>
                    <StepAccordion steps={data?.WhatYouWillLearn}/>
                </div>
            </div>
        </section>
    )
}

export default WhatYouWillLearn